import { z } from 'zod'

// The browser completes the Google flow with Supabase and posts the
// resulting access token here exactly once, to be exchanged for a session
// cookie. The Supabase token is never used as the session itself: it cannot
// be revoked when the owner deactivates a staff member.
export const exchangeSession = z.object({
  accessToken: z.string().min(10).max(4096),
})
export type ExchangeSession = z.infer<typeof exchangeSession>
